import React from 'react';

import './Item.less';
import { IconButton } from '@material-ui/core';
import { Edit, Delete } from '@material-ui/icons';
import RenderingImage from '../../common/RenderingImage';

export default function NewsListItem(props) {
  const {
    header, 
    uploadedOn,
    onHeaderClick,
    imageId,
    showActions,
    onEdit,
    onRemove,
    tags,
  } = props

  return (
    <div className="news-list-wrapper">
      <div onClick={onHeaderClick} className="news-list-image">
        {imageId &&
          <RenderingImage url={`/minioFiles/download/${imageId}`}/>
        }
      </div>

      <div as="article" className="news-list-item">
        <div className="item-tags">
          <span className="item-uploaded">{uploadedOn}</span>
          <span className="item-list-tag">
            {tags.map((e, i) => (
              <span key={i}>
                {i > 0 && (
                  <b
                    style={{
                      paddingLeft: '8px',
                      paddingRight: '8px',
                    }}
                  >
                    ·
                  </b>
                )}
                {e.name}
              </span>
            ))}
          </span>
        </div>
        <h3 onClick={onHeaderClick} className="item-header">
          {header}
        </h3>
        {showActions && (
          <div className="news-list-item news-list-item-actions">
            <IconButton onClick={onEdit} style={{ borderRadius: 0, padding: '0px' }}>
              <Edit style={{ color: '#305FFD' }} />
            </IconButton>
            <IconButton onClick={onRemove} style={{ borderRadius: 0, padding: '0px' }}>
              <Delete style={{ color: '#dc3545' }} />
            </IconButton>
          </div>
        )}
      </div>
    </div>
  );
}
